var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-1 flex overflow-y-auto p-4 -m-4"},[_c('tabs',{attrs:{"selected":_vm.tabs.selected,"tabs":_vm.tabs.list},on:{"select":_vm.selectTab},scopedSlots:_vm._u([{key:"content-fieldadmin",fn:function(){return [_c('FieldAdmin')]},proxy:true},{key:"content-blockadmin",fn:function(){return [_c('BlockAdmin')]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }